export const MODAL_TRANSITION_DURATION = 300 /** in ms */
